<template>
  <div class="bar">
    <div class="spacer">
      <BackButton class="header-back-link" />
    </div>
    <div class="home-link">
      <a href="https://www.unihomes.co.uk/shared-student-utility-bills">
        <Logo class="logo" />
      </a>
    </div>
    <div class="spacer"></div>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton";
import Logo from "@/assets/svg/logo.svg";

export default {
  name: "NavBar",
  components: {
    BackButton,
    Logo,
  },
};
</script>

<style lang="scss" scoped>
.bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 2;
  height: 70px;

  background-color: $brand-blue;
  display: flex;
  align-items: center;

  @include media("<medium") {
    height: 60px !important;
  }

  .home-link {
    color: $white;
    background-color: $brand-blue;

    display: flex;
    align-items: center;

    height: 120%;
    padding: 0 40px;
    box-shadow: 0 0 15px #00000029;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;

    .logo {
      width: 162px;
      height: 35px;
    }
  }
}

.header-back-link {
  color: white;
  padding: 0 1rem;
  background: none;
  border: none;
  font-size: 16px;

  &:focus {
    outline: none;
  }

  @include media(">=medium") {
    display: none;
  }
}
</style>
